import React from "react";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import {Button} from "primereact/button";
import {Divider} from "@material-ui/core";
import NumberFormat from "react-number-format";
import {InputText} from "primereact/inputtext";
import {RadioButton} from "primereact/radiobutton";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";

const PaymentView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{
                       paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%',
                       overflow: 'auto'
                   }}>
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <div className="p-col-8" align="right">
                        <TitlePage title={props.screenName}/>
                    </div>
                    <div className="p-col-4" align="right">
                        <Button label="Cancelar" className="p-button-secondary"
                                onClick={props.returnCorporateActionPage}/>&nbsp;
                        <Button label="Guardar" onClick={props.applyCorporateAction}/>
                    </div>
                    <div className="p-col-12">
                        <Divider/>
                    </div>
                    <div className="p-col-12">
                        <SubtitleLabel header="Emisora" isBold={true}/>
                        <SubtitleLabel header={props.dataCorporateAction.fullInstrument}/>
                    </div>
                    <div className="p-col-12">
                        <SubtitleLabel header="Descripción" isBold={true}/>
                        <SubtitleLabel header={props.dataCorporateAction.descrCorporateAction}/>
                    </div>
                    <div className="p-col-12">
                        <SubtitleLabel header="Préstamo" isBold={true}/>
                    </div>
                    <div className="p-col-12">
                        <DataTable
                            value={props.loanPayList}
                            responsive={true}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column field="idFolioPrest" header="Folio"
                                    sortable={true} style={{textAlign: 'left'}}/>
                            <Column field="nomCorto" header="Institución"
                                    sortable={true} style={{textAlign: 'left'}}/>
                            <Column field="tipo" header="Tipo"
                                    sortable={true} style={{textAlign: 'left'}}/>
                            <Column field="tipoPago" header="Tipo de Pago"
                                    sortable={true} style={{textAlign: 'left'}}/>
                        </DataTable>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Ratio" isBold={true}/>
                        <NumberFormat decimalScale={2}
                                      id={3} name="ratio"
                                      placeholder={"Ex: 99,99"}
                                      required={true}
                                      customInput={InputText}
                                      value={props.ratio}
                                      onChange={props.handleChangeValue}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Forma de Pago" isBold={true}/>
                        <RadioButton inputId="rb1" name="paymentType" value="0"
                                     checked={props.paymentType === '0'}
                                     onChange={props.saveRadioButtonOption}/>
                        <label htmlFor="rb2" className="p-radiobutton-label">Efectivo</label>
                        &nbsp;&nbsp;
                        <RadioButton inputId="rb1" name="paymentType" value="1"
                                     checked={props.paymentType === '1'}
                                     onChange={props.saveRadioButtonOption}/>
                        <label htmlFor="rb2" className="p-radiobutton-label">Especie</label>
                    </div>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default PaymentView;